import * as React from 'react'
// @ts-ignore
import IntersectionVisible from 'react-intersection-visible'

export interface ContentProps {
    content?: React.ReactNode
    goToComment?: (id: string) => void
    onContentBottomReached?: (visible: boolean) => void
    onContentTopReached?: (visible: boolean) => void
    targetId?: string
}

export const Content: React.FC<ContentProps> = (props) => {
    const onContentBottomReached = (entries: any) => {
        const isContentBottomReached: boolean = entries[0].isIntersecting
        props.onContentBottomReached &&
            props.onContentBottomReached(isContentBottomReached)
    }

    const onContentTopReached = (entries: any) => {
        const isContentTopReached: boolean = entries[0].isIntersecting
        props.onContentTopReached &&
            props.onContentTopReached(isContentTopReached)
    }

    return (
        <>
            <IntersectionVisible
                onIntersect={(e: any) => onContentTopReached(e)}
            />
            {props.content}
            <IntersectionVisible
                onIntersect={(e: any) => onContentBottomReached(e)}
            />
        </>
    )
}
